import styled from '@emotion/styled';
import { NakedButton, Icon, Text } from '@qga/roo-ui/components';
import { FC, MouseEventHandler } from 'react';

const InlineFlexButton = styled(NakedButton)`
  display: inline-flex;
  align-items: center;
  font-weight: normal;
`;

interface EditButtonWithIconProps {
  onClick: MouseEventHandler<HTMLButtonElement>;
}

const EditButtonWithIcon: FC<EditButtonWithIconProps> = (props) => (
  <InlineFlexButton {...props} color="brand.primary" aria-label="Edit Details Button">
    <Text fontSize="base">Edit Details</Text>
    <Icon name="modeEdit" title="Edit Details" size={18} ml={1} />
  </InlineFlexButton>
);

export default EditButtonWithIcon;
